import type { InputState } from '../input/keyboard';

export interface PlayerLike {
  x: number;
}

export interface PlayerMoveOptions {
  speed: number;
  minX: number;
  maxX: number;
}

export function updatePlayer(
  player: PlayerLike,
  input: Readonly<InputState>,
  dtMs: number,
  opts: PlayerMoveOptions,
): void {
  const dir = (input.right ? 1 : 0) - (input.left ? 1 : 0);
  if (dir === 0 || dtMs <= 0) return;
  const next = player.x + dir * opts.speed * (dtMs / 1000);
  player.x = Math.max(opts.minX, Math.min(opts.maxX, next));
}
